/** @format */

import styled from 'styled-components';

export const Button = styled.button`
  --text-color: var(--gray-900, #101828);
  --background-color: ${({ theme }) => theme.colors.joivy.white};
  padding: 0.625rem 1rem;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25rem;
  color: var(--text-color);
  background: var(--background-color);
  border: none;
  outline: none;
  cursor: pointer;
  border-radius: 0.5rem;

  transition: all 0.5s cubic-bezier(0.36, 0.33, 0, 1) 0s;
`;

export const PrimaryButton = styled(Button)`
  --text-color: ${({ theme }) => theme.colors.joivy.white};
  --background-color: ${({ theme }) => theme.colors.joivy['teal-dark']};
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

  &:hover {
    --background-color: #005058;
  }

  &:disabled {
    --background-color: #99bcc0;
  }
`;

export const TextButton = styled(Button)`
  --text-color: var(--gray-600, #475467);
  --background-color: transparent;

  &:hover {
    --text-color: var(--gray-700);
  }

  &:disabled {
    --text-color: var(--gray-300);
  }
`;

export const SecondaryButton = styled.button`
  --text-color: var(--gray-900, #101828);
  --background-color: ${({ theme }) => theme.colors.joivy.white};
  --border-color: var(--gray-300, #d0d5dd);

  border-radius: 0.5rem;
  color: var(--text-color);
  border: 1px solid var(--border-color);
  background: var(--background-color);

  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

  cursor: pointer;

  transition: all 0.5s cubic-bezier(0.36, 0.33, 0, 1) 0s;

  display: flex;
  align-items: center;
  gap: 0.5rem;

  img {
    display: block;
    max-width: 100%;
    font-style: italic;
  }

  &:hover {
    --backgorund-color: var(--gray-50);
    --text-color: var(--gray-800);
    --border-color: var(--gray-300);
  }
  &:disabled {
    --border-color: var(--gray-200);
    --text-color: var(--gray-300);
  }
`;

export const FilterButton = styled(SecondaryButton)`
  padding: 0.625rem 1.125rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;
`;

export const FilterTitle = styled.span`
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5rem;
  text-align: start;
`;
